export class TimelineElement {
    id: number;
    legende: string;
    date: Date;
    titre: string;
    selected?: boolean;
    contenu: string;
    photo: string;
}
